// permission.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissions: any[] = [];

  constructor() {
    this.loadPermissions();
  }

  private loadPermissions() {
    const storedPermissions = window.localStorage.getItem('permission');
    if (storedPermissions) {
      this.permissions = JSON.parse(storedPermissions);
    }
  }

  // Optionally, you can provide a method to update permissions and sync with localStorage
  updatePermissions(permissions: any[]) {
    this.permissions = permissions;
    window.localStorage.setItem('permission', JSON.stringify(permissions));
  }

  checkPermission(id: string, action: string): boolean {
    const result = this.permissions.filter((res) => res.permissionId === id);
    return result.length > 0 && result[0][action] === 'true';
  }
}
